import { closeModal as close, openModal as open } from '@core-ui/reducers_handlers';

export const reducerName = 'modals';

export const openModal = open(reducerName);
export const closeModal = close(reducerName);
